<template>
  <span
    class="my-tag"
    :style="{
      padding: padding,
      border: `1px solid ${color}`,
      borderRadius: border,
      backgroundColor: backgroundColor,
      color: color,
      fontSize: size,
    }"
  >
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "",
    },
    padding: {
      type: String,
      default: "3px",
    },
    border: {
      type: String,
      default: "4px",
    },
    backgroundColor: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "8px",
    },
  },
};
</script>

<style lang="less" scoped>
.my-tag {
  box-sizing: border-box;
}
</style>
